import React,{useState, useEffect, useRef} from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { COOKIESPREFIX } from './config';
import './App.css';
//screens
import Home from './screens/Home.js'
import Verify from './screens/Verify.js'
import Rules from './screens/Rules.js'
import UserPick from './screens/UserPick.js'
import GameMap from './screens/GameMap.js'
import Result from './screens/Result.js'
//
import {getUserInfo} from './services/service.js'
import { useLocation } from 'react-router-dom';

function App() {
  const [isLogin, setIsLogin] = useState(true);
  useEffect(() => {
    const handleLogin = async () => {
      const password = await prompt('please input username')
      if(password === 'bocpreview') setIsLogin(true)
    }
    if(!isLogin){
      handleLogin()
    }
  },[]);

  const location = useLocation();

  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
  const [gameData, setGameData] = useState(null)
  const handleSetGameData = (data) => setGameData(data)
  useEffect(() => {
    async function getGameState(){
      const userToken = cookies[`@${COOKIESPREFIX}_token`]
      if(!userToken) return;
      const res = await getUserInfo(userToken)
      if(res.data === null || res.errno) {
        removeCookie(`@${COOKIESPREFIX}_token`)
        return navigate('/')
      }
      const gameInfo = res.data?.data
      console.log(gameInfo)
      setGameData(res.data)
      if(!gameInfo?.category) return navigate('/rules')
      // if(!gameInfo.progress1 || !gameInfo.progress2) return navigate('/gamemap')
      // if(gameInfo.progress1 && gameInfo.progress2) return navigate('/gamemap')
    }
    getGameState()
  },[])


  if(!isLogin)return <div>401 Unauthorized</div>
  return (
    <div className="App full-viewport-height">
      <div className='app-main w-full text-black h-[100%] overflow-y-scroll overflow-x-hidden z-[10]'>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/index.html' element={<Home/>} />
          <Route path='/verify' element={<Verify/>} />
          <Route path='/rules' element={<Rules/>} />
          <Route path='/usertype' element={<UserPick />} />
          <Route path='/gamemap/:prize' element={<GameMap />} />
          <Route path='/gamemap' element={<GameMap />} />
          <Route path='/info' element={<Result />} />
          <Route path='/*' element={<Home />} />

        </Routes>
      </div>
      <div style={{ position: 'absolute', top:0, left:0,right:0,bottom:0,zIndex:9,background: '#e6e7e8' }}>
          <video 
            style={{ position: 'absolute', top: 0, left: 0, width:'100%',opacity: ['/','','index.html','/gamemap'].includes(location.pathname)?0:1}} 
            loop={true} 
            muted={true}
            controls={false}
            autoPlay
            playsInline 
            src='/bgloopv2.mp4' />
      </div>
    </div>
  );
}

export default App;
